module.exports = __webpack_public_path__ + "static/media/51.8c368c96.jpg";